interface FieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: string;
  autoComplete?: string;
  required?: boolean;
  placeholder?: string;
  delay?: number;
}

export function Field({
  label,
  value,
  onChange,
  type = "text",
  autoComplete,
  required,
  placeholder,
  delay = 0,
}: FieldProps) {
  return (
    <div className="animate-fade-up" style={{ animationDelay: `${delay}ms` }}>
      <label className="label mb-2 block text-ink-walnut">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        required={required}
        placeholder={placeholder}
        className="field-input"
      />
    </div>
  );
}
